import { styled } from 'baseui'

export const StyledDisclaimer = styled('div', () => ({
  marginBottom: '1.25rem'
}))
